import { Client } from '@stomp/stompjs';
import { TOPICS } from 'context/realtime/Subscription';
import { PRESENCE_HEARTBEAT_MS } from 'context/realtime/presenceClock';
import { getToken } from 'services/auth';
import { emitEvent } from 'utils';

const HOST = process.env.REACT_APP_API_HOST || '';

const toWsUrl = () => {
    const token = encodeURIComponent(getToken() || '');
    if (HOST) {
        return `${HOST.replace(/^http/, 'ws')}/api/ws-chat?token=${token}`;
    }
    const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${proto}//${window.location.host}/api/ws-chat?token=${token}`;
};

export function createChatSocket({ onEvent, onAdminEvent, communityId, isAdmin }) {
    let client = null;
    let attempt = 0;
    let stopped = false;
    let reconnectTimer = null;
    let pingTimer = null;

    const clearPing = () => {
        clearInterval(pingTimer);
        pingTimer = null;
    };

    const ping = () => {
        if (client?.connected) {
            client.publish({ destination: '/app/presence/ping', body: '{}' });
        }
    };

    const connect = () => {
        if (stopped) {
            return;
        }
        client = new Client({
            brokerURL: toWsUrl(),
            reconnectDelay: 0,
            onConnect: () => {
                attempt = 0;
                client.subscribe('/user/queue/chat', (message) => {
                    onEvent(JSON.parse(message.body));
                });
                if (communityId) {
                    client.subscribe(`/topic/community/${communityId}/presence`, (message) => {
                        emitEvent(TOPICS.PRESENCE, JSON.parse(message.body));
                    });
                }
                if (isAdmin) {
                    client.subscribe('/user/queue/chat-admin', (message) => {
                        onAdminEvent(JSON.parse(message.body));
                    });
                    if (communityId) {
                        client.subscribe(`/topic/community/${communityId}/chat-admin`, (message) => {
                            onAdminEvent(JSON.parse(message.body));
                        });
                    }
                }
                ping();
                clearPing();
                pingTimer = setInterval(ping, PRESENCE_HEARTBEAT_MS);
            },
            onWebSocketClose: () => {
                clearPing();
                if (stopped) {
                    return;
                }
                const delay = Math.min(30000, 1000 * (2 ** attempt));
                attempt += 1;
                reconnectTimer = setTimeout(connect, delay);
            },
        });
        client.activate();
    };

    connect();

    return {
        disconnect() {
            stopped = true;
            clearPing();
            clearTimeout(reconnectTimer);
            if (client) {
                client.deactivate();
            }
        },
    };
}
